module.exports = __webpack_public_path__ + "html/task.template.html";